import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPhone,
  faCircle,
  faEnvelope,
  faBolt,
  faCalendarAlt,
  faBell,
  faPencilAlt,
  faBinoculars,
  faTrashAlt,
  faDollarSign,
  faExclamation
} from '@fortawesome/pro-solid-svg-icons';

import { getTaskTypeLabel } from 'helpers/tasks/helpers';

export default class TaskIcon extends React.Component {
  static propTypes = {
    icon: PropTypes.object,
    iconClass: PropTypes.string,
    showTooltip: PropTypes.bool,
    size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
    standalone: PropTypes.bool,
    taskIsComplete: PropTypes.bool,
    type: PropTypes.string.isRequired
  };

  static defaultProps = {
    showTooltip: true,
    size: 'lg'
  };

  taskIcon() {
    if (this.props.icon) return this.props.icon;

    switch (this.props.type) {
    case 'email':
      return faEnvelope;
    case 'call':
      return faPhone;
    case 'meeting':
      return faCalendarAlt;
    case 'other':
      return faBolt;
    case 'note':
      return faPencilAlt;
    case 'showing':
      return faBinoculars;
    case 'deleted':
      return faTrashAlt;
    case 'voucher_approval':
      return faDollarSign;
    case 'critical_date':
      return faExclamation;
    default:
      return faBell;
    }
  }

  determineIconClass = () => {
    if (this.props.iconClass) return this.props.iconClass;
    if (this.props.taskIsComplete) return 'text-task-complete';

    return this.props.type ? `text-${this.props.type.replace(/_/g, '-')}` : `text-other`;
  }

  render() {
    const { showTooltip, size, standalone, type } = this.props;

    if (standalone) {
      return (
        <FontAwesomeIcon fixedWidth icon={this.taskIcon()} />
      );
    }

    const iconClass = this.determineIconClass();
    const spanClass = `fa-stack fa-${size}`;
    const icon = (
      <span className={spanClass}>
        <FontAwesomeIcon className={`fa-stack-2x activity ${iconClass}`} fixedWidth icon={faCircle} size={size} />
        <FontAwesomeIcon
          className={`fa-stack-1x fa-inverse ${this.props.size == 'lg' ? 'mr-0' : ''}`}
          fixedWidth
          icon={this.taskIcon()}
          size={size}
        />
      </span>
    );

    if (!showTooltip) return icon;

    const tooltip = <Tooltip id={`task-icon-${type}`}>{getTaskTypeLabel(type)}</Tooltip>;

    return (
      <div className="m-0">
        <OverlayTrigger overlay={tooltip} placement="bottom">{icon}</OverlayTrigger>
      </div>
    );
  }
}
